<template>
  <v-toolbar
    color="primary"
    fixed
    dark
    app
  >
    <v-toolbar-title class="ml-0 pl-3">
      <v-toolbar-side-icon @click.stop="handleDrawerToggle"></v-toolbar-side-icon>
    </v-toolbar-title>
    <!-- <v-text-field
        flat
        solo-inverted
        prepend-icon="search"
        label="Search"
        class="hidden-sm-and-down"
        >
      </v-text-field> -->
    <v-spacer></v-spacer>
    <!-- <v-btn href="mailto:wangqiangshen@gmail.com">
        Hire Me
      </v-btn>       -->
    <!-- <v-btn icon href="https://github.com/tookit/vue-material-admin">
        <v-icon>fa fa-github</v-icon>
      </v-btn> -->
    <v-btn
      icon
      @click="handleFullScreen()"
    >
      <v-icon>fullscreen</v-icon>
    </v-btn>
    <v-menu
      offset-y
      origin="center center"
      class="elelvation-1"
      :nudge-bottom="14"
      transition="scale-transition"
    >
      <v-btn
        icon
        flat
        slot="activator"
      >
        <v-badge
          color="red"
          overlap
        >
          <span slot="badge">{{ notificationCount }}</span>
          <v-icon medium>notifications</v-icon>
        </v-badge>
      </v-btn>
      <notification-list ref="refNotification"></notification-list>
    </v-menu>
    <v-menu
      offset-y
      origin="center center"
      :nudge-bottom="10"
      transition="scale-transition"
    >
      <v-btn
        icon
        large
        flat
        slot="activator"
      >
        <!-- <v-avatar size="30px">
          <img
            src="/static/avatar/man_4.jpg"
            alt="Michael Wang"
          />
        </v-avatar> -->
        <v-avatar class="primary mx-1 white--text">{{ appUserName.slice(0, 2).toUpperCase() }}</v-avatar>

      </v-btn>
      <v-list class="pa-0">
        <v-list-tile
          v-for="(item,index) in items"
          :to="!item.href ? { name: item.name } : null"
          :href="item.href"
          @click="item.click"
          ripple="ripple"
          :disabled="item.disabled"
          :target="item.target"
          rel="noopener"
          :key="index"
        >
          <v-list-tile-action v-if="item.icon">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-menu>
    <!-- <v-btn
      icon
      large
      flat
      @click="openThemeSettings"
    >
      <v-icon>settings</v-icon>
    </v-btn> -->

  </v-toolbar>

</template>
<script>
import NotificationList from '@/components/widgets/list/NotificationList';
import ThemeSettings from '@/components/ThemeSettings';
import { getNotification } from '@/api/notification';
import Util from '@/util';
export default {
  name: 'app-toolbar',
  components: {
    NotificationList,
    ThemeSettings,
  },
  data: () => ({
    rightDrawer: false,
    appUserName: '',
    notificationCount: 0,
    noticationItems: [],
    timer: '',
    items: [
      {
        icon: 'account_circle',
        href: '#',
        title: 'Profile',
        click: e => {
          console.log(e);
        }
      },
      {
        icon: 'settings',
        href: '#',
        title: 'Settings',
        click: e => {
          window.getApp.$emit('APP_THEME_TOGGLED');
        }
      },
      {
        icon: 'fullscreen_exit',
        href: '#',
        title: 'Logout',
        click: e => {
          window.getApp.$emit('APP_LOGOUT');
        }
      }
    ]
  }),
  beforeDestroy () {
    clearInterval(this.timer)
  },
  created () {

    if (this.$store.state.auth.userName != undefined) {
      this.appUserName = this.$store.state.auth.userName;
    }
    else {
      window.getApp.$emit('APP_LOGOUT');
    }

    this.getNotifications();
    this.timer = setInterval(this.getNotifications, 30000)
  },
  computed: {
    toolbarColor () {
      return this.$vuetify.options.extra.mainNav;
    }
  },
  methods: {
    handleDrawerToggle () {
      window.getApp.$emit('APP_DRAWER_TOGGLED');
    },
    handleFullScreen () {
      Util.toggleFullScreen();
    },
    openThemeSettings () {
      // this.$vuetify.goTo(0);
      // console.log(this.$refs);
      // this.rightDrawer = !this.rightDrawer;
      window.getApp.$emit('APP_THEME_TOGGLED');

    },
    getNotifications () {
      getNotification(this.$store.state.auth.userId)
        .then(response => {
          this.noticationItems = response.data;
          this.$refs.refNotification.items = this.noticationItems;

          this.notificationCount = this.noticationItems.length;
        })
        .catch(error => {
          // window.getApp.$emit('APP_API_ERROR', error);
        });
    },


  }
};
</script>



// WEBPACK FOOTER //
// src/components/AppToolbar.vue